<template>
    <div class="audio-file-upload-status">
        <div class="upload-status">
            <i class="fas" :class="['upload-status-icon', iconClasses]" />
            {{ message }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        type: {
            required: true,
            type: String,
        },
        message: {
            required: true,
            type: String,
        },
    },

    computed: {
        /**
         * Gets classes for icon based on type.
         *
         * @returns {object} Icon classes.
         */
        iconClasses() {
            return {
                'fa-info-circle info-icon': 'info' === this.type,
                'fa-times-circle error-icon': 'error' === this.type,
            };
        },
    },
};
</script>
